import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { Dispatch, ActionCreator, UnknownAction } from "redux";

import { ApplicationState } from "../store/ApplicationState";
import { NotifyInternalDataUpdateDispatchTypes } from "../models/DispatchTypes/Patient";
import { NotifyInternalData } from "../models/Patient";
import { NotifyInternalDataUpdateActionDispatchTypes } from "../constants/Patient";
import { getMasterApiCall } from "../constants/Constants";


export const resetStates: ActionCreator<
  ThunkAction<void, ApplicationState, Record<string, never>, any>
> = (actionType: string[]) => {
  return async (dispatch: Dispatch) => {
    return actionType.map((singleAction) => {
      dispatch({
        type: singleAction,
      });
    });
  };
};

export const notifyInternalDataUpdates: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    NotifyInternalDataUpdateDispatchTypes
  >
> = (value: NotifyInternalData) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: NotifyInternalDataUpdateActionDispatchTypes.NOTIFY_INTERNAL_DATA_UPDATE_INVOKE,
    });
    dispatch({
      response: value,
      type: NotifyInternalDataUpdateActionDispatchTypes.NOTIFY_INTERNAL_DATA_UPDATE_SUCCESS,
    });
  };
};

export const masterApiCall: ActionCreator<
  ThunkAction<void, ApplicationState, Record<string, never>, UnknownAction >
> = (actionType: string) => {
  return async (
    dispatch: ThunkDispatch<ApplicationState, Record<string, never>, UnknownAction >
  ) => {
    return dispatch(getMasterApiCall(actionType));
  };
};
